import tagTester from './_tagTester.js';

export default tagTester('RegExp');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isRegExp.js
// module id = 1338
// module chunks = 9